import React from 'react';
import { 
  ListItem, 
  IconButton, 
  ListItemIcon, 
  ListItemText 
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';

const DocumentItem = ({ icon, label, url }) => {
  return (
    <ListItem 
      secondaryAction={
        <IconButton edge="end" onClick={() => window.open(url, '_blank')}>
          <VisibilityIcon color="primary" />
        </IconButton>
      }
      sx={{ px: 0 }}
    >
      <ListItemIcon sx={{ color: 'primary.main' }}>
        {icon}
      </ListItemIcon>
      <ListItemText 
        primary={label} 
        primaryTypographyProps={{ variant: 'body2' }}
      />
    </ListItem>
  );
};

export default DocumentItem;